import { gql } from '@urql/core';
import React from 'react';
import { EditableMyPlayerCardFragment, Espin_Player_Profile } from '../../../../generated/spin-graphql';
import { PictureWithFallback } from '../../../sections/PictureWithFallback';

type Props = {
    player: EditableMyPlayerCardFragment;
    onRemove: () => void;
    canRemove?: boolean;
};

gql`
    fragment EditableMyPlayerCard on espin_player_profile {
        profile_image {
            ...SpinContentImageDisplay
        }
        spin_username

        first_name
        last_name
        user {
            email
        }
    }
`;

export const EditableMyPlayerCard: React.FC<Props> = ({ player, onRemove, canRemove = true }) => {
    return (
        <div className="my-player-card">
            <div className="image-wrapper">
                <PictureWithFallback
                    icon={player.profile_image}
                    width={60}
                    height={60}
                    alt={`${player.spin_username}} profile picture`}
                />
            </div>
            <div className="name-container">
                <h2 className="username">{player.spin_username}</h2>
                <p className="name">{`${player.first_name} ${player.last_name}`}</p>
                <p className="email">{player.user.email}</p>
            </div>
            {canRemove && (
                <button onClick={onRemove} className="button medium-button red-button">
                    Remove
                </button>
            )}
        </div>
    );
};
